import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import Navbar from './components/Navbar';

// Pages
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import LandingPage from './pages/LandingPage';
import PendingOrders from './pages/PendingOrders';
import OrderCreate from './pages/OrderCreate';
import OrderEdit from './pages/OrderEdit';
import OrderDetail from './pages/OrderDetail';
import ShippingManagement from './pages/ShippingManagement';
import UserManagement from './pages/UserManagement';
import MaterialList from './pages/MaterialList';
import MaterialForm from './pages/MaterialForm';
import HeadquartersReport from './pages/HeadquartersReport';
import AccountSettings from './pages/AccountSettings';
import VatManagement from './pages/VatManagement';
import SupplierManagement from './pages/SupplierManagement';
import BuyerManagement from './pages/BuyerManagement';
import StockIntake from './pages/StockIntake';
import StockOuttake from './pages/StockOuttake';
import StockMonitoring from './pages/StockMonitoring';
import FulfillmentDashboard from './pages/FulfillmentDashboard';
import OrderPicking from './pages/OrderPicking';
import FulfilledOrders from './pages/FulfilledOrders';
import QscList from './pages/QscList';
import QscNew from './pages/QscNew';
import QscDetail from './pages/QscDetail';
import QscImprovementReview from './pages/QscImprovementReview';
import QscTemplateManager from './pages/QscTemplateManager';
import RecipeCostCalculator from './pages/RecipeCostCalculator';
import RecipeList from './pages/RecipeList';
import RecipeDetail from './pages/RecipeDetail';
import RecipeEdit from './pages/RecipeEdit';
import MaterialPriceHistory from './pages/MaterialPriceHistory';
import MyOrders from './pages/MyOrders';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/login" element={<Login />} />

            <Route path="/" element={
              <PrivateRoute>
                <>
                  <Navbar />
                  <LandingPage />
                </>
              </PrivateRoute>
            } />

            <Route path="/dashboard" element={
              <PrivateRoute>
                <>
                  <Navbar />
                  <Dashboard />
                </>
              </PrivateRoute>
            } />

            <Route path="/pending-orders" element={
              <PrivateRoute requireScope="orders:manage">
                <>
                  <Navbar />
                  <PendingOrders />
                </>
              </PrivateRoute>
            } />

            <Route path="/hq-report" element={
              <PrivateRoute requireScope="reports:hq">
                <>
                  <Navbar />
                  <HeadquartersReport />
                </>
              </PrivateRoute>
            } />

            <Route path="/my-orders" element={
              <PrivateRoute requireScope="orders:create">
                <>
                  <Navbar />
                  <MyOrders />
                </>
              </PrivateRoute>
            } />

            <Route path="/orders/create" element={
              <PrivateRoute requireAnyScope={['orders:create', 'orders:manage']}>
                <>
                  <Navbar />
                  <OrderCreate />
                </>
              </PrivateRoute>
            } />

            <Route path="/orders/:id/edit" element={
              <PrivateRoute>
                <>
                  <Navbar />
                  <OrderEdit />
                </>
              </PrivateRoute>
            } />

            <Route path="/orders/:id" element={
              <PrivateRoute>
                <>
                  <Navbar />
                  <OrderDetail />
                </>
              </PrivateRoute>
            } />

            <Route path="/shipping" element={
              <PrivateRoute requireScope="shipping">
                <>
                  <Navbar />
                  <ShippingManagement />
                </>
              </PrivateRoute>
            } />

            <Route path="/users" element={
              <PrivateRoute requireSuperuser>
                <>
                  <Navbar />
                  <UserManagement />
                </>
              </PrivateRoute>
            } />

            <Route path="/materials" element={
              <PrivateRoute requireScope="materials:manage">
                <>
                  <Navbar />
                  <MaterialList />
                </>
              </PrivateRoute>
            } />

            <Route path="/materials/:id/price-history" element={
              <PrivateRoute requireScope="materials:manage">
                <>
                  <Navbar />
                  <MaterialPriceHistory />
                </>
              </PrivateRoute>
            } />

            <Route path="/materials/create" element={
              <PrivateRoute requireScope="materials:manage">
                <>
                  <Navbar />
                  <MaterialForm />
                </>
              </PrivateRoute>
            } />

            <Route path="/materials/:id/edit" element={
              <PrivateRoute requireScope="materials:manage">
                <>
                  <Navbar />
                  <MaterialForm />
                </>
              </PrivateRoute>
            } />

            <Route path="/account" element={
              <PrivateRoute>
                <>
                  <Navbar />
                  <AccountSettings />
                </>
              </PrivateRoute>
            } />

            <Route path="/vat" element={
              <PrivateRoute requireScope="vat">
                <>
                  <Navbar />
                  <VatManagement />
                </>
              </PrivateRoute>
            } />

            <Route path="/suppliers" element={
              <PrivateRoute requireScope="suppliers">
                <>
                  <Navbar />
                  <SupplierManagement />
                </>
              </PrivateRoute>
            } />

            <Route path="/buyers" element={
              <PrivateRoute requireScope="buyers">
                <>
                  <Navbar />
                  <BuyerManagement />
                </>
              </PrivateRoute>
            } />

            <Route path="/stock/monitoring" element={
              <PrivateRoute requireScope="stock:monitoring">
                <>
                  <Navbar />
                  <StockMonitoring />
                </>
              </PrivateRoute>
            } />

            <Route path="/stock/intake" element={
              <PrivateRoute requireScope="stock:intake">
                <>
                  <Navbar />
                  <StockIntake />
                </>
              </PrivateRoute>
            } />

            <Route path="/stock/outtake" element={
              <PrivateRoute requireScope="stock:outtake">
                <>
                  <Navbar />
                  <StockOuttake />
                </>
              </PrivateRoute>
            } />

            <Route path="/fulfillment" element={
              <PrivateRoute requireScope="fulfillment">
                <>
                  <Navbar />
                  <FulfillmentDashboard />
                </>
              </PrivateRoute>
            } />

            <Route path="/fulfilled-orders" element={
              <PrivateRoute requireScope="fulfillment">
                <>
                  <Navbar />
                  <FulfilledOrders />
                </>
              </PrivateRoute>
            } />

            <Route path="/picking/:orderId" element={
              <PrivateRoute requireScope="fulfillment">
                <>
                  <Navbar />
                  <OrderPicking />
                </>
              </PrivateRoute>
            } />

            <Route path="/qsc" element={
              <PrivateRoute>
                <>
                  <Navbar />
                  <QscList />
                </>
              </PrivateRoute>
            } />

            <Route path="/qsc/new" element={
              <PrivateRoute requireScope="qsc:manage">
                <>
                  <Navbar />
                  <QscNew />
                </>
              </PrivateRoute>
            } />

            <Route path="/qsc/improvements" element={
              <PrivateRoute requireScope="qsc:improvements">
                <>
                  <Navbar />
                  <QscImprovementReview />
                </>
              </PrivateRoute>
            } />

            <Route path="/qsc/templates" element={
              <PrivateRoute requireScope="qsc:manage">
                <>
                  <Navbar />
                  <QscTemplateManager />
                </>
              </PrivateRoute>
            } />

            <Route path="/qsc/:id" element={
              <PrivateRoute>
                <>
                  <Navbar />
                  <QscDetail />
                </>
              </PrivateRoute>
            } />

            <Route path="/recipes" element={
              <PrivateRoute requireScope="recipes">
                <>
                  <Navbar />
                  <RecipeList />
                </>
              </PrivateRoute>
            } />

            <Route path="/recipes/new" element={
              <PrivateRoute requireScope="recipes">
                <>
                  <Navbar />
                  <RecipeCostCalculator />
                </>
              </PrivateRoute>
            } />

            <Route path="/recipes/:id/edit" element={
              <PrivateRoute requireScope="recipes">
                <>
                  <Navbar />
                  <RecipeEdit />
                </>
              </PrivateRoute>
            } />

            <Route path="/recipes/:id" element={
              <PrivateRoute requireScope="recipes">
                <>
                  <Navbar />
                  <RecipeDetail />
                </>
              </PrivateRoute>
            } />

            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
